import { render, staticRenderFns } from "./DetailWpsCompany.vue?vue&type=template&id=1a705193&scoped=true"
import script from "./DetailWpsCompany.vue?vue&type=script&lang=js"
export * from "./DetailWpsCompany.vue?vue&type=script&lang=js"
import style0 from "./DetailWpsCompany.vue?vue&type=style&index=0&id=1a705193&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a705193",
  null
  
)

export default component.exports